import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useAppApi } from "@/App";
import { SteamGiftOrderGiftState, SteamGiftOrderState } from "@/const";
import { useRequest } from "@components/AppHook";
import { ExportButton } from "@components/Common/Button";
import { DevForm } from "@components/Forms/Fields";
import { GameToBrowserButton } from "@components/Game/Misc";
import { DevModal } from "@components/Helpers";
import { DefaultLayout } from "@components/Layouts";
import { ListingCard } from "@components/Pages";
import { parseQS, url_reverse } from "@components/Utils";

export default function MarketSteamGiftOrderScreen() {
    return (
        <DefaultLayout>
            <List />
        </DefaultLayout>
    );
}

function List() {
    const { t } = useTranslation();
    const { apiData, apiUrl, setApiReget } = useAppApi(url_reverse("api:market:steam_gift_order:list"));
    const [orderInfo, setOrderInfo] = useState(null);
    const [refund, setRefund] = useState(null);
    const { api_post } = useRequest();

    if (!apiData) return;

    const refundClose = () => {
        setRefund(null);
    };

    const refundHandle = (ev) => {
        if (!refund.transaction_id) {
            alert("refund_transaction_id");
        }

        api_post(ev, apiUrl, {
            params: { order_id: refund.order_id, refund_transaction_id: refund.transaction_id },
            then: (resp) => {
                if (resp.status === "ok") {
                    refundClose();
                    setApiReget(true);
                }
            },
        });
    };

    const headerTools = <ExportButton size="sm" prms={parseQS()} />;

    return (
        <ListingCard header={t("Покупки через Steam gift bot")} headerTools={headerTools}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Login</th>
                        <th>Game</th>
                        <th>{t("Состояние")}</th>
                        <th>{t("Транзакция")}</th>
                        <th>{t("Дата создания")}</th>
                        <th>{t("Дата оплаты")}</th>
                        <th>{t("Сумма оплаты")}</th>
                        <th>payment_error</th>
                        <th>gift_state</th>
                        <th>gift_error</th>
                        <th>{t("Возврат")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o) => {
                        return (
                            <tr key={`object_list${o.id}`}>
                                <td>
                                    <a
                                        href="#"
                                        onClick={(ev) => {
                                            ev.preventDefault();
                                            setOrderInfo(o);
                                        }}
                                    >
                                        {o.id}
                                    </a>
                                </td>
                                <td>{o.login}</td>
                                <td>
                                    <Link to={url_reverse("games:page", { game_id: o.game_id })}>
                                        {o.game.base_locale_object.name}
                                    </Link>
                                    <GameToBrowserButton game={o.game} />
                                </td>
                                <td>{o.state}</td>
                                <td>{o.payment_id}</td>
                                <td>{o.date_ordered}</td>
                                <td>{o.date_payed}</td>
                                <td>{o.payment_sum}</td>
                                <td>{o.payment_error}</td>
                                <td>{SteamGiftOrderGiftState[o.gift_state]}</td>
                                <td>{o.gift_error}</td>
                                <td>
                                    {o.state === SteamGiftOrderState.PAYED && (
                                        <DevForm.Button
                                            variant="warning"
                                            size="sm"
                                            name="refund"
                                            onClick={() => setRefund({ order_id: o.id })}
                                        >
                                            {t("Возврат")}
                                        </DevForm.Button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
            <DevModal
                show={refund}
                onHide={refundClose}
                header={t("Сделать возврат")}
                body={
                    <DevForm.TextInput
                        name="transaction_id"
                        placeholder="refund_transaction_id"
                        value={refund?.transaction_id}
                        onChange={(ev) => setRefund((prev) => ({ ...prev, transaction_id: ev.target.value }))}
                    />
                }
                footer={
                    <DevForm.Button variant="primary" name="action" value="make_refund" onClick={refundHandle}>
                        {t("Возврат")}
                    </DevForm.Button>
                }
            />
            <DevModal
                size="lg"
                show={orderInfo}
                onHide={() => setOrderInfo(null)}
                header={`#${orderInfo?.id}`}
                body={
                    orderInfo && (
                        <Table size="sm" bordered striped responsive style={{ fontSize: "10pt" }}>
                            <tbody>
                                <tr>
                                    <th style={{ minWidth: "220px" }}>user_id</th>
                                    <td>{orderInfo.user_id}</td>
                                </tr>
                                <tr>
                                    <th>date_refund</th>
                                    <td>{orderInfo.date_refund}</td>
                                </tr>
                                <tr>
                                    <th>receipt_email</th>
                                    <td>{orderInfo.receipt_email}</td>
                                </tr>
                                <tr>
                                    <th>account_link</th>
                                    <td>{orderInfo.account_link}</td>
                                </tr>
                                <tr>
                                    <th>account_region</th>
                                    <td>{orderInfo.account_region}</td>
                                </tr>
                                <tr>
                                    <th>{t("Тип платежа")}</th>
                                    <td>{orderInfo.payment_type}</td>
                                </tr>
                                <tr>
                                    <th>order_extra</th>
                                    <td>{JSON.stringify(orderInfo.order_extra, null, 2)}</td>
                                </tr>
                            </tbody>
                        </Table>
                    )
                }
            />
        </ListingCard>
    );
}
